import React, {useEffect, useImperativeHandle, useRef, useState} from "react";
import {useModel} from "../../../models";
import {DICT_KEY, getDictNameByCode} from "../../../utils/constants";

//服务站
const borderStyle = {
    border: "1px double #000",
}
const PrintTitle = () => {
    return (
        <h3 style={{
            textAlign: "center",
            fontSize: "18pt",
            fontFamily: "楷体,楷体_GB2312",
        }}>
            天路云卡汽车销售有限公司
        </h3>
    )
};
const PrintHeader = ({
                         params: {
                             saleCode,
                             customerId,
                             createTime,
                             customerPerson,
                             customerPhone,
                             invoiceType,
                             contactWeiChai,
                             contactUs,
                             detailedAddress,
                             paymentMethodName
                         }
                     }) => {
    return (
        <div>
            <div style={{display: "flex"}}>
                <div style={{
                    flex: "4",
                    textAlign: "left"
                }}>
                    销售单号:<span style={{marginLeft: "12px"}}>{saleCode}</span>
                </div>
                <div
                    style={{
                        flex: "5",
                        textAlign: "left"
                    }}
                >
                    客户名称:
                    <span style={{marginLeft: "12px"}}>
                        {getDictNameByCode(DICT_KEY.CM_DICT.CUSTOMER, customerId)}
                    </span>
                </div>
                <div
                    style={{
                        flex: "3",
                        textAlign: "left"
                    }}
                >
                    支付方式:<span style={{marginLeft: "12px"}}>{paymentMethodName}</span>
                </div>
            </div>
            <div style={{display: "flex"}}>
                <div style={{
                    flex: "4",
                    textAlign: "left"
                }}>
                    制单日期:<span style={{marginLeft: "12px"}}>{createTime}</span>
                </div>
                <div
                    style={{
                        flex: "5",
                        textAlign: "left"
                    }}
                >
                    联系人:<span style={{marginLeft: "12px"}}>{customerPerson}</span>
                </div>
                <div
                    style={{
                        flex: "3",
                        textAlign: "left"
                    }}
                >
                    联系我们:<span style={{marginLeft: "12px"}}>{contactUs}</span>
                </div>
            </div>
            <div style={{display: "flex"}}>
                <div style={{
                    flex: "4",
                    textAlign: "left"
                }}>
                    发票类型:
                    <span style={{marginLeft: "12px"}}>
                        {getDictNameByCode(DICT_KEY.CM_DICT.INVOICE_TYPE, invoiceType)}
                    </span>
                </div>
                <div
                    style={{
                        flex: "5",
                        textAlign: "left"
                    }}
                >
                    联系方式:<span style={{marginLeft: "12px"}}>{customerPhone}</span>
                </div>
                <div
                    style={{
                        flex: "3",
                        textAlign: "left"
                    }}
                >
                    联系潍柴:<span style={{marginLeft: "12px"}}>{contactWeiChai}</span>
                </div>
            </div>
        </div>
    )
}

const TableTotal = ({
                        params: {
                            discount,
                            discountAmount,
                            saleTotalNum,
                            aggregateAmount
                        }
                    }) => {
    return (
        <div style={{display: "flex"}}>
            <div style={{
                flex: "1",
                textAlign: "left"
            }}>
                整单折扣:<span style={{marginLeft: "12px"}}>{discount}%</span>
            </div>
            <div style={{
                flex: "1",
                textAlign: "left"
            }}>
                优惠总金额:<span style={{marginLeft: "12px"}}>{discountAmount}</span>
            </div>
            <div
                style={{
                    flex: "1",
                    textAlign: "left"
                }}
            >
                销售总数量:<span style={{marginLeft: "12px"}}> {saleTotalNum}</span>
            </div>
            <div
                style={{
                    flex: "1",
                    textAlign: "left"
                }}
            >
                应收金额: <span style={{marginLeft: "12px"}}>{aggregateAmount}</span>
            </div>
        </div>
    )
}
const PrintFooter = ({
                         params: {
                             saleDesc,
                             createUser
                         }
                     }) => {
    return (
        <div style={{display: "flex",}}>
            <div style={{
                flex: "2",
                textAlign: "left"
            }}> 备注:<span style={{marginLeft: "12px"}}>{saleDesc}</span></div>
            <div
                style={{
                    flex: "1",
                    textAlign: "left"
                }}>操作员:<span style={{marginLeft: "12px"}}>{createUser}</span></div>
        </div>
    )
}

const PrintTable = ({
                        params: {
                            mappedList,
                            discount,
                            discountAmount,
                            saleTotalNum,
                            aggregateAmount

                        }
                    }) => {

    return (
        <table
            border="0"
            align="center"
            style={{
                borderCollapse: "collapse",
            }}
            width="100%"
        >
            <thead style={{display: "table-header-group",}}>
            <tr>
                <th style={borderStyle}>配件编码</th>
                <th style={borderStyle}>配件名称</th>
                <th style={borderStyle}>图号</th>
                <th style={borderStyle}>货位</th>
                <th style={borderStyle}>商品类型</th>
                <th style={borderStyle}>数量</th>
                <th style={borderStyle}>赠品</th>
                <th style={borderStyle}>含税单价</th>
                <th style={borderStyle}>含税金额</th>
            </tr>
            </thead>
            <tbody>
            {
                mappedList.map(el => (
                    <tr key={el.id}>
                        <td style={borderStyle}>{el.materialCode}</td>
                        <td style={borderStyle}>{el.materialName}</td>
                        <td style={borderStyle}>{el.replaceNum}</td>
                        <td style={borderStyle}>{el.shelfCode}</td>
                        <td style={borderStyle}>{el.category}</td>
                        <td style={borderStyle}>{el.saleNum}</td>
                        <td style={borderStyle}>{el.giftsNum}</td>
                        <td style={borderStyle}>{el.avgPrince}</td>
                        <td style={borderStyle}>{el.amount}</td>
                    </tr>))
            }
            <tr bgcolor="#d3d3d3">
                <td style={borderStyle} colSpan={9}>
                    <TableTotal params={{
                        discount,
                        discountAmount,
                        saleTotalNum,
                        aggregateAmount
                    }}/>
                </td>
            </tr>
            </tbody>
            <tfoot>
            {/*<tr>
                <td colSpan={9}>

                </td>
            </tr>*/}
            </tfoot>
        </table>
    )
}


export default ({printRef}) => {
    const ref = useRef();
    useImperativeHandle(printRef, () => ({
        dom: () => {
            return ref.current;
        },
    }));

    const [{setting: {contactWeiChai, contactUs}}] = useModel("global");
    const [{
        selectedDocument: {
            paymentMethodName,
            createTime,
            createUser,
        },
        documentMaterialList,
        detailStatistics: {saleTotalNum},
        formData: {
            saleCode,
            customerId,
            customerPerson,
            customerPhone,
            invoiceType,
            discount = 100,
            discountAmount = 0,
            aggregateAmount = 0,
            saleDesc,
            detailedAddress,
        },
    },] = useModel("saleSo");
    useEffect(() => {

    }, [customerId])
    const mappedList = documentMaterialList.map(el => {
        const {isProtect, salePrice, saleNum, giftsNum, discount, discountPrice} = el;
        const amount0 = isProtect === "1" ? 0 : salePrice * (saleNum - giftsNum) * discount / 100 - discountPrice
        //平均价
        let avgPrince = amount0 / saleNum;
        if (!!!avgPrince) {
            avgPrince = 0
        }
        //四舍五入
        avgPrince = avgPrince.toFixed(2);
        const amount = (avgPrince * el.saleNum).toFixed(2);

        //上进位
        /*
        avgPrince = (Math.ceil(avgPrince * 100) / 100).toFixed(2);
        const amount = (Math.ceil(avgPrince * el.saleNum * 100) / 100).toFixed(2);
        */

        return {
            ...el,
            avgPrince,
            amount
        };
    });

    return (
        <div ref={ref} hidden={true}>
            <div style={{width: "800px", margin: "0 auto"}}>
                <PrintTitle/>
                <PrintHeader params={{
                    saleCode,
                    customerId,
                    createTime,
                    customerPerson,
                    customerPhone,
                    invoiceType,
                    discountAmount,
                    contactWeiChai,
                    contactUs,
                    detailedAddress,
                    paymentMethodName
                }}/>
                <PrintTable params={{
                    mappedList,
                    discount,
                    discountAmount,
                    saleTotalNum,
                    aggregateAmount
                }}/>
                <PrintFooter params={{saleDesc, createUser}}/>
            </div>
        </div>
    )
}